{
  "AGENT_BOTS": {
    "HEADER": "Robôs",
    "LOADING_EDITOR": "Carregando Editor...",
    "DESCRIPTION": "Robôs agentes são como os membros mais fabulosos de seu time. Eles podem lidar com as pequenas coisas, assim você pode focar nas coisas que importam. Dê uma chance a eles. Você pode gerenciar seus robôs a partir desta página ou criar novos usando o botão 'Criar Robô'.",
    "LEARN_MORE": "Aprenda sobre os robôs agentes",
    "COUNT": "{n} robô | {n} robôs",
    "SEARCH_PLACEHOLDER": "Pesquisar robôs...",
    "NO_RESULTS": "Nenhum robô encontrado correspondente à sua busca",
    "GLOBAL_BOT": "Robô do sistema",
    "GLOBAL_BOT_BADGE": "Sistema",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar do robô excluído com sucesso",
      "ERROR_DELETE": "Erro ao excluir o avatar do robô, tente novamente"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Selecione um robô de agente",
      "DESC": "Atribua um Agente Robô à sua caixa de entrada. Eles podem lidar com as conversas iniciais e transferi-las para um agente humano quando necessário.",
      "SUBMIT": "Atualizar",
      "DISCONNECT": "Desconectar Robô",
      "SUCCESS_MESSAGE": "Agente de bot atualizado com sucesso.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Bot desconectado com sucesso.",
      "ERROR_MESSAGE": "Não foi possível atualizar o agente robô. Por favor, tente novamente mais tarde.",
      "DISCONNECTED_ERROR_MESSAGE": "Não foi possível desconectar o agente robô. Por favor, tente novamente mais tarde.",
      "SELECT_PLACEHOLDER": "Selecionar Robô"
    },
    "ADD": {
      "TITLE": "Criar Robô",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Bot adicionado com sucesso.",
        "ERROR_MESSAGE": "Não foi possível adicionar o agente robô! Por favor, tente novamente mais tarde."
      }
    },
    "LIST": {
      "404": "Nenhum robô encontrado. Você pode criar um robô clicando no botão 'Criar Robô'.",
      "LOADING": "Buscando robôs...",
      "TABLE_HEADER": {
        "DETAILS": "Detalhe do Robô",
        "URL": "URL do Webhook",
        "ACTIONS": "Ações"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Excluir",
      "TITLE": "Deletar robô",
      "CONFIRM": {
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem certeza que deseja excluir {name}?",
        "YES": "Sim, excluir",
        "NO": "Não, Mantenha"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot excluído com sucesso.",
        "ERROR_MESSAGE": "Não foi possível excluir o robô. Por favor, tente novamente."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Alterar",
      "TITLE": "Alterar Robô",
      "API": {
        "SUCCESS_MESSAGE": "Robô atualizado com sucesso.",
        "ERROR_MESSAGE": "Não foi possível atualizar o robô. Por favor, tente novamente mais tarde."
      }
    },
    "SECRET": {
      "LABEL": "Segredo do Webhook",
      "COPY": "Copiar segredo para a área de transferência",
      "COPY_SUCCESS": "Segredo copiado para a área de transferência",
      "TOGGLE": "Alternar visibilidade do segredo",
      "CREATED_DESC": "Use o segredo abaixo para verificar as assinaturas do webhook. Copie-o agora, você também poderá encontrá-lo depois nas configurações do robô.",
      "DONE": "Concluído",
      "RESET_SUCCESS": "Segredo do webhook regenerado com sucesso",
      "RESET_ERROR": "Não foi possível regenerar o segredo do webhook. Por favor, tente novamente"
    },
    "ACCESS_TOKEN": {
      "TITLE": "Token de acesso",
      "DESCRIPTION": "Copie o token de acesso e salve-o de forma segura",
      "COPY_SUCCESSFUL": "Token de acesso copiado para área de transferência",
      "RESET_SUCCESS": "Token de acesso gerado novamente com sucesso",
      "RESET_ERROR": "Não foi possível regerar o token de acesso. Por favor, tente novamente"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar do robô"
      },
      "NAME": {
        "LABEL": "Nome do Robô",
        "PLACEHOLDER": "Insira o nome do robô",
        "REQUIRED": "O nome do Robô é obrigatório"
      },
      "DESCRIPTION": {
        "LABEL": "Descrição",
        "PLACEHOLDER": "O que esse robô faz?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL do Webhook",
        "PLACEHOLDER": "https://exemplo.com.br/webhook",
        "REQUIRED": "URL Webhook é necessária"
      },
      "ERRORS": {
        "NAME": "O nome do Robô é obrigatório",
        "URL": "URL Webhook é necessária",
        "VALID_URL": "Digite uma URL válida começando com http:// ou https://"
      },
      "CANCEL": "Cancelar",
      "CREATE": "Criar um Robô",
      "UPDATE": "Atualizar o Robô"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure um robô de Webhook para integrar com seus serviços personalizados. O robô receberá e processará eventos de conversas e pode respondê-los."
    },
    "TYPES": {
      "WEBHOOK": "Webhook robô"
    }
  }
}
